import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { ConceptGroupsListPage } from '@verantos-dev/feature-concept-groups-list';

const APP_ID = EvidencePlatformSidebarAppID.conceptGroups;

export const ConceptGroupsUiRoutes = () => {
  useAppId(APP_ID);

  return (
    <Routes>
      <Route index element={<ConceptGroupsListPage />} />
    </Routes>
  );
};

export default withAuth(ConceptGroupsUiRoutes, APP_ID);
